"use strict";
/**
 * @module Services.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a AUTHENTICATOR_REGISTRATION request.
 */
var AuthenticatorRegistrationRequest = /** @class */ (function () {
    /**
     * Create a new AuthenticatorRegistrationRequest instance
     *
     * @param params  the authentication control registration parameters
     * @param cid     the conversation ID
     */
    function AuthenticatorRegistrationRequest(params, cid) {
        this.params = params;
        this.cid = cid;
    }
    return AuthenticatorRegistrationRequest;
}());
exports.AuthenticatorRegistrationRequest = AuthenticatorRegistrationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-registration-request.js
// module id = 1364
// module chunks = 1